import React, { FC } from 'react';
import { ResponseTimeProps } from './props';
import './styles.scss';

export const ResponseTime: FC<ResponseTimeProps> = ({ averageResponseTime }) => {
  return (
    <div className="ta-carousel-card-response-time">
      <h3 className="ta-carousel-card-response-time__waiting-offers">Very responsive</h3>

      <div className="ta-carousel-card-response-time__waiting-offers-item">
        <span>Usually replies in:</span>

        <span>{averageResponseTime}</span>
      </div>
    </div>
  );
};
